import { takeEveryFsa } from "../operations";
import { dashboardActions } from "./actions";
import { dashboardApi } from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";

export function* dashboardSaga() {
    yield takeEveryFsa(dashboardActions.fetchDashboardData.started, function* (action) {
        yield* makeAsyncApiCall(action, dashboardActions.fetchDashboardData, dashboardApi);    
    })
}